import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";

export interface NotificationsDialogData {
  digiPagerText: string;
  isInHouseGroupOrder: boolean;
}

@Component({
  selector: "notificationsDialog",
  templateUrl: "./notificationsDialog.component.html",
  styleUrls: ["./notificationsDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class NotificationsDialogComponent implements OnInit {

  constructor(
    public bottomSheetRef: MatBottomSheetRef<NotificationsDialogComponent, boolean>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public dialogData: NotificationsDialogData
  ) { }

  ngOnInit() { }

  public setNotification() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }

  public discardToMenuGroup() {
    const me = this;
    me.bottomSheetRef.dismiss(false);
  }
}
